import { inject, Injectable } from '@angular/core';
import { TaskDescriptionAcknowledgement } from '@app/shared/types/models/task/task-description-acknowledgement.model';
import { Observable } from 'rxjs';
import { TaskDescriptionAcknowledgementsDataService } from '../task-description-acknowledgements-data.service';

/**
 * TaskDescriptionAcknowledgementsActionsService - Facade for task description acknowledgement mutations.
 *
 * Thin wrapper around {@link TaskDescriptionAcknowledgementsDataService} for components and views.
 *
 * Scope: Global (`providedIn: 'root'`).
 *
 * Usage: Used when the UI needs to create description acknowledgements without talking to the data layer directly.
 *
 * Architecture:
 * - {@link TaskDescriptionAcknowledgementsActionsService}: User-triggered acknowledgement actions
 * - {@link TaskDescriptionAcknowledgementsDataService}: Caching, store updates, notifications
 * - {@link TaskDescriptionAcknowledgementsHttpService}: HTTP API calls
 */
@Injectable({ providedIn: 'root' })
export class TaskDescriptionAcknowledgementsActionsService {
  private readonly acknowledgementsDataService = inject(TaskDescriptionAcknowledgementsDataService);

  public createAcknowledgement(taskId: string): Observable<TaskDescriptionAcknowledgement> {
    return this.acknowledgementsDataService.createAcknowledgement(taskId);
  }
}
